module.exports = __webpack_public_path__ + "assets/arrow-right-icon.be9afe1c.svg";